<div class="fill-height d-flex bg-white" #scrollContainer>

  <article class="home-background-con">
    <img class="home-background" src="assets/images/home-bg.png" alt="background image">
  </article>

  <div *ngIf="isLoading" class="d-flex h-100 align-items-center justify-content-center">
    <mat-spinner class="zx-small-icon-size"></mat-spinner>
  </div>
  <div *ngIf="!isLoading" class="w-100 d-flex flex-column h-100 align-items-center">

    <!-- === UPPER CONTENT === -->
    <div class="w-100 d-flex h-100 row p-0 justify-content-center">

      <!-- TEXT CON -->
      <div
        class="d-flex flex-column justify-content-center align-items-center h-small-h-md-unset col-12 col-md-8 col-lg-6 col-xl-5 p-0">
        <div class="d-flex flex-column main-title-width zx-z-index-2">

          <!-- 1st line -->
          <span class="d-flex align-items-end justify-content-center pt-1">
            <span class="zx-home-t-big">
              {{ 'about-us.main-title-1' | translate }}
            </span>
            <span class="zx-home-t-big" style="opacity: 0;">-</span>
            <span *ngIf="typedText !== '' && typedText !== 'about-us.main-title-2.'">
              <span class="zx-100-opp" style="font-size: 2px;">.</span>
              <span class="zx-home-t-device">
                {{ typedText }}
              </span>
              <span class="zx-100-opp" style="font-size: 2px;">.</span>
            </span>
            <span class="zx-home-t-big" style="opacity: 0;">-</span>
          </span>

          <!-- 2nd line -->
          <span class="zx-home-t-medium pb-1 text-center">
            {{ 'about-us.main-title-3' | translate }}
          </span>

          <!-- intro - long -->
          <span class="w-100 text-center px-3 zx-font-heebo-small py-4">
            {{ "about-us.explain-us" | translate }}
          </span>

          <!-- try it brn -->
          <div class="pt-3 w-100 pt-md-5 d-flex justify-content-center">
            <button mat-stroked-button class="rounded-pill try-now-btn zx-border-dark zx-text-tiny zx-text-sm-small"
              (click)="goHome()">
              {{ "q-and-a.1.btn-try-print" | translate }}
            </button>
          </div>

        </div>
      </div>

      <!-- video -->
      <!-- <div class="col-12 d-flex justify-content-center align-items-center p-0 video-container">
        <video *ngIf="!isIphone()" #videoPlayer loop muted class="box-video p-0" preload="auto"
          alt="Printing Box Annotation" [class.box-video-scrolled]="getHeightForAnimation() > 900">
          <source src="assets/videos/box-video.webm" type="video/webm">
          <source src="assets/videos/box-video.mp4" type="video/mp4">
        </video>
      </div>

      <div *ngIf="isIphone()"
        class="col-12 d-flex justify-content-center align-items-center p-0 video-container h-100 w-100">
        <img src="assets/images/box-video-placeholder.png" alt="Eazix Printer" class="box-video p-0">
      </div> -->

      <div class="col-12 d-flex justify-content-center align-items-center p-0 video-container">
        <img *ngIf="isIphone()" src="assets/images/box-video-placeholder.png" alt="Eazix Printer" class="box-video p-0"
          [class.box-video-scrolled]="getHeightForAnimation() > 900">
        <video *ngIf="!isIphone()" #videoPlayer loop muted class="box-video p-0" preload="auto"
          alt="Printing Box Annotation" [class.box-video-scrolled]="getHeightForAnimation() > 900">
          <source src="assets/videos/box-video.webm" type="video/webm">
          <source src="assets/videos/box-video.mp4" type="video/mp4">
        </video>
      </div>

      <!-- MOUSE SCROLLER -->
      <div class="w-100">
        <div class="scroll-downs">
          <div class="mousey">
            <div class="scroller"></div>
          </div>
        </div>
      </div>

      <!-- === second container === -->
      <div class="w-100 d-flex flex-column" style="transform: translateY(-150px);">

        <!-- TEXT intro -->
        <div class="w-100 d-flex flex-column justify-content-center px-4 text-intro gap-3">

          <!-- three steps -->
          <div class="row p-0 d-flex justify-content-center text-white hide-animate"
            [class.show-animate]="getHeightForAnimation() > 900">
            <span
              [ngClass]="{'shake-animate': animatingStep > 0 && animatingStep <= 5, 'unique-class-2': animatingStep > 1 && animatingStep <= 3}"
              class="col-3 col-md-2 d-flex justify-content-center align-items-center h-100" style="transform: 300ms;">
              <span class="d-flex justify-content-center text-center rounded-1 zx-bg-home-item step-1 w-100">
                {{ "about-us.main-explain-1" | translate }}
              </span>
            </span>
            <span
              [ngClass]="{'shake-animate': animatingStep > 3 && animatingStep <= 8, 'unique-class-2': animatingStep > 3 && animatingStep <= 5}"
              class="col-3 col-md-2 d-flex justify-content-center align-items-center h-100" style="transform: 300ms;">
              <span class="d-flex justify-content-center text-center rounded-1 zx-bg-home-item step-2 w-100">
                {{ "about-us.main-explain-2" | translate }}
              </span>
            </span>
            <span
              [ngClass]="{'shake-animate': animatingStep > 6 && animatingStep <= 11, 'unique-class-2': animatingStep > 5 && animatingStep <= 7}"
              class="col-3 col-md-2 d-flex justify-content-center align-items-center h-100" style="transform: 300ms;">
              <span class="d-flex justify-content-center text-center rounded-1 zx-bg-home-item step-3 w-100">
                {{ "about-us.main-explain-3" | translate }}
              </span>
            </span>
          </div>

          <!-- 4th step -->
          <span style="transform: 300ms;" [class.show-animate]="getHeightForAnimation() > 965"
            [ngClass]="{'shake-animate-light': animatingStep > 9 && animatingStep <= 16, 'unique-class-2': animatingStep > 9 && animatingStep <= 16}"
            class="w-100 text-center zx-font-heebo-medium fw-bold px-4 pt-1 hide-animate text-blue-dark">
            {{ "about-us.main-explain-4" | translate }}
          </span>

          <!-- try it brn -->
          <div class="d-flex justify-content-center w-100 hide-animate-fade pb-1 zx-z-index-1"
            [class.show-animate-fade]="getHeightForAnimation() > 997">
            <button mat-stroked-button
              class="rounded-pill try-now-btn zx-border-dark zx-text-tiny zx-text-sm-small zx-z-index-1"
              (click)="goHome()">
              {{ "q-and-a.1.btn-try-branches" | translate }}
            </button>
          </div>

          <!-- from any device title -->
          <div class="w-100 d-flex justify-content-center align-items-center hide-animate-bottom pt-5"
            [class.show-animate-bottom]="getHeightForAnimation() > 1100"
            [class.show-animate-bottom-not-rtl]="getHeightForAnimation() > 1100 && !isRTL">
            <!-- title -->
            <span class="d-flex align-items-end pt-5 zx-text-medium">
              <span class="pb-1">
                {{ "about-us.devices-explain-1" | translate }}
              </span>
              <span style="opacity: 0;">-</span>
              <span *ngIf="typedTextDevice !== '' && typedTextDevice !== 'about-us.main-title-2.'"
                class="zx-home-t-device-small">
                <span class="zx-100-opp" style="font-size: 12px;">.</span>
                <span>
                  {{ typedTextDevice }}
                </span>
                <span class="zx-100-opp" style="font-size: 12px;">.</span>
              </span>
              <span class="zx-home-t-big" style="opacity: 0;">-</span>
            </span>
            <!-- arrow -->
            <div class="arrow-curve" [class.arrow-curve-not-rtl]="!isRTL"></div>
          </div>
          <!-- // from any device title -->

        </div>
        <!-- // TEXT intro -->

        <!-- device IMAGE -->
        <div class="d-flex justify-content-center align-items-center h-big-h-md-100 col-12 p-0 position-relative"
          style="max-height: 820px;">
          <div *ngFor="let device of devices; let i = index" class="slide-image-con"
            [class.slide-image-con-not-rtl]="!isRTL">
            <img [@slideInOut]="device === imgDevice ? 'in' : 'out'"
              [src]="'assets/images/home-media/home-' + device + '-' + getLang() + '.png'" alt="Eazix App Image"
              class="slide-image">
          </div>
        </div>
        <!-- // device IMAGE -->

      </div>
      <!-- // === second container === -->

      <!-- action BTN -->
      <div class="w-100 d-flex flex-column flex-lg-row p-2 px-lg-5 shadow-85-strong zx-z-index-1 gap-2"
        style="transform: translateY(-150px);">
        <button type="button" mat-button color="primary" (click)="goToQAndA()"
          class="text-green rounded-pill w-100 zx-medium-btn fw-bold">
          {{ "main-nav.q-and-a" | translate }}
        </button>
        <button type="button" mat-raised-button color="primary" (click)="goHome()"
          class="text-white rounded-pill w-100 zx-medium-btn zx-main-btn-effects fw-bold">
          {{ "main-nav.new-order" | translate }}
        </button>
        <span *ngIf="isIphone()" style="height: 70px;"></span>
      </div>
      <!-- // action BTN -->

    </div>
    <!-- // === UPPER CONTENT === -->

  </div>
</div>